import { render } from "./areasubmit.vue?vue&type=template&id=6ca392fb&ts=true"
import script from "./areasubmit.vue?vue&type=script&lang=ts"
export * from "./areasubmit.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__